import { render, staticRenderFns } from "./banner-action.vue?vue&type=template&id=318f85da&"
import script from "./banner-action.vue?vue&type=script&lang=js&"
export * from "./banner-action.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports